import { FC } from "react"
import { useTranslation } from "react-i18next"

import { UText } from "../../components"
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
} from "../../components/mui.components"
import { Volume } from "../../core/app/slices/pricing/pricingSlice"

export const VolumeCard: FC<{
  isStl?: boolean
  title: string
  volume: Volume
}> = ({ isStl, title, volume }) => {
  const { t } = useTranslation()

  const getCount = (
    alignerCount: string | number,
    retainerCount: string | number,
  ) => {
    return (
      <Box component={"div"} sx={{ visibility: isStl ? "hidden" : "" }}>
        <UText
          component={"div"}
          variant="body2"
          sxProp={{ color: "text.secondary", lineHeight: "143%" }}
        >
          Aligners {alignerCount}
        </UText>
        <UText
          variant="body2"
          component={"div"}
          sxProp={{ color: "text.secondary", lineHeight: "143%" }}
        >
          Retainers {retainerCount}
        </UText>
      </Box>
    )
  }
  return (
    <Card
      className="volume-card"
      sx={{ borderColor: isStl ? "#215ECD" : "#16AADC" }}
    >
      <CardHeader
        className="volume-header"
        title={
          <Box className="volume-title">
            <UText variant="body1" color="text.secondary">
              {title}
            </UText>
          </Box>
        }
      />
      <CardContent
        sx={{
          display: "flex",
          flexGrow: 1,
          "&.MuiCardContent-root": { padding: 4 },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ textAlign: "center" }}>
            <Box>
              <UText
                variant="body1"
                sxProp={{ fontWeight: 500, lineHeight: "175%" }}
              >
                {t("Pricing.volume.currentMonthVol")}
              </UText>
            </Box>
            <UText
              variant="h3"
              className="volume-value"
              sxProp={{ color: isStl ? "#4A00D5" : null }}
            >
              {volume?.CurrentTotal}
            </UText>
            {getCount(volume?.CurrentAligner, volume?.CurrentRetainer)}
          </Grid>
          <Grid item xs={6} sx={{ textAlign: "center" }}>
            <Box>
              <UText
                variant="body1"
                sxProp={{ fontWeight: 500, lineHeight: "175%" }}
              >
                {t("Pricing.volume.sixMonthVol")}
              </UText>
            </Box>
            <UText
              variant="h3"
              className="volume-value"
              sxProp={{ color: isStl ? "#4A00D5" : null, py: "4px" }}
            >
              {volume?.SixTotal}
            </UText>
            {getCount(volume?.SixAligner, volume?.SixRetainer)}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
